module.exports = __webpack_public_path__ + "images/category_lp/camera/SIGMA-APO-300-800mm-F5.6-EX-DG-HSM_df6a66f8d8967e12294b2c5810b0c9c3.png";